import React from 'react';
import get from 'lodash/get';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Subject} from 'rxjs/Subject';
import {createSelector} from 'reselect';
import compose from 'recompose/compose';
import {FormattedMessage} from 'react-intl';
import {bool, func, string} from 'prop-types';
import setDisplayName from 'recompose/setDisplayName';
import {Modal, Button, TextArea, Label} from 'semantic-ui-react';
import {EmptyFunc} from 'utils/DBUtils';
import {TEXT_INPUT_DEBOUNCE_TIME} from 'Config';
import {isNoU} from "../../utils/DBUtils";

class EditWinnerNotesModal extends React.Component {
    static propTypes = {
        isOpen: bool.isRequired,
        isInFlight: bool.isRequired,
        handleClose: func.isRequired,
        hasSaveError: bool.isRequired,
        handleSubmit: func.isRequired,
        notes: string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            notes: props.notes
        };
    }

    changeEmitter = new Subject().debounceTime(TEXT_INPUT_DEBOUNCE_TIME);

    handleChange = (event, data) => {
        this.changeEmitter.next(data.value);
    };

    handleClose = (event, data) => {
        if (!this.props.isInFlight) {
            this.props.handleClose();
        }
    };

    handleSubmit = (event, data) => {
        this.props.handleSubmit(this.state.notes);
    };

    componentDidMount() {
        this.setState({notes: this.props.notes});
        this.changeEmitter.subscribe(notes => this.setState({notes}));
    }

    get className() {
        return classnames('primary-modal edit-winner-story-modal', {
            'error-modal': this.props.hasSaveError
        });
    }

    get canSubmit() {
        return !(this.props.isInFlight || this.props.hasSaveError);
    }

    render() {
        return (
            <Modal
                size='tiny'
                dimmer={true}
                closeIcon={true}
                open={this.props.isOpen}
                closeOnDimmerClick={true}
                onClose={this.handleClose}
                className={this.className}>
                <Modal.Header>
                    <FormattedMessage id='winnersList.modal.notes.header' />
                </Modal.Header>
                <Modal.Content>
                    {this.props.hasSaveError && (
                        <Label className='db-error-label'>
                            <FormattedMessage id='winnersList.modal.notes.error' />
                        </Label>
                    )}
                    <TextArea
                        onChange={this.handleChange}
                        value={this.state.notes} />
                    <Button
                        primary={true}
                        disabled={!this.canSubmit}
                        onClick={this.handleSubmit}
                        loading={this.props.isInFlight}>
                        <FormattedMessage id='buttons.save' />
                    </Button>
                </Modal.Content>
            </Modal>
        );
    }
}

const selectNotes = createSelector(
    state => state.resources.resources[state.listWinners.editingWinnerNotes],
    currentWinner => {
        if (isNoU(currentWinner)) {
            return "";
        }

        const {fulfillmentNotes} = currentWinner;
        return fulfillmentNotes || "";
    }
);

export default compose(
    setDisplayName('EditWinnerNotesModal'),
    connect(state => ({
        notes: selectNotes(state)
    }))
)(EditWinnerNotesModal);



// WEBPACK FOOTER //
// ./public/pages/ListWinners/EditWinnerNotesModal.jsx